import React from "react";
import { Link } from "react-router-dom";

export default function Index() {
  const games = [
    {
      id: 1,
      title: "Count with Bucked X",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Count With Bucked X/index.html",
      app_link: "countwithbuckedxpro://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Count With Bucked X/icon.png",
    },
    {
      id: 2,
      title: "Count with Bucked",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Count With Bucked/index.html",
      app_link: "countwithbuckedpro://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Count With Bucked/icon.png",
    },
    {
      id: 3,
      title: "Beach Skater",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Beach Skater/index.html",
      app_link: "parkourpro://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Beach Skater/icon.png",
    },
    {
      id: 4,
      title: "Math Space",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Math Space/index.html",
      app_link: "mathspacepro://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Math Space/icon.png",
    },
    {
      id: 5,
      title: "Trivia Drive",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Trivia Drive/index.html",
      app_link: "triviadrivepro://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Trivia Drive/icon.png",
    },
    {
      id: 6,
      title: "Trivia Flight",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Trivia Flight/index.html",
      app_link: "triviaflightpro://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Trivia Flight/icon.png",
    },
    {
      id: 7,
      title: "Sudoku",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Sudoku/index.html",
      app_link: "shapesudokupro://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Sudoku/icon.png",
    },
    {
      id: 8,
      title: "Time Tapper",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Time Tapper/index.html",
      app_link: "timetapper3d://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Time Tapper/icon.png",
    },
    {
      id: 9,
      title: "Misspelling",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Misspelling/index.html",
      app_link: "misspelling://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Misspelling/icon.png",
   },
    {
      id: 10,
      title: "Super Math Market",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Super Math Market/index.html",
      app_link: "supermathmarket://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Super Math Market/icon.png",
    },
    {
      id: 11,
      title: "Current Chase",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Current Chase/index.html",
      app_link: "currentchaser://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Current Chase/icon.png",
    },
    {
      id: 12,
      title: "ECO",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/ECO/index.html",
      app_link: "ECO://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/ECO/icon.png",
    },
    {
      id: 13,
      title: "Cumhuriyet ile Geleceğe",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Cumhuriyet_ile_Gelecege/index.html",
      app_link: "cumhuriyetilegelecege://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Cumhuriyet_ile_Gelecege/icon.png",
    },
    {
      id: 14,
      title: "Image To Sound",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Image To Sound/index.html",
      app_link: "imagetosound://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Image To Sound/icon.png",
    },
    {
      id: 15,
      title: "Image To Text",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Image To Text/index.html",
      app_link: "imagetotext://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Image To Text/icon.png",
    },
    {
      id: 16,
      title: "Make It Number",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Make It Number/index.html",
      app_link: "makeitnumber://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Make It Number/icon.png",
    },
    {
      id: 17,
      title: "Related Words",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Related Words/index.html",
      app_link: "relatedwords://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Related Words/icon.png",
    },
    {
      id: 18,
      title: "Text To Text",
      link: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Text To Text/index.html",
      app_link: "texttotext://",
      image: "https://bucketgames.metodbox.com/Bucked_WebGL_2024/Text To Text/icon.png",
    },
  ];

  const showToast = (message) => {
    const overlay = document.createElement("div");
    overlay.style.position = "fixed";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = "100%";
    overlay.style.height = "100%";
    overlay.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
    overlay.style.zIndex = 1000;
    overlay.style.display = "flex";
    overlay.style.justifyContent = "center";
    overlay.style.alignItems = "center";

    const toast = document.createElement("div");
    toast.innerText = message;
    toast.style.maxWidth = "70%";
    toast.style.padding = "20px 40px";
    toast.style.backgroundColor = "#ea5455";
    toast.style.color = "#ffff";
    toast.style.borderRadius = "5px";
    toast.style.position = "relative";

    const closeButton = document.createElement("button");
    closeButton.innerText = "X";
    closeButton.style.position = "absolute";
    closeButton.style.top = "10px";
    closeButton.style.right = "10px";
    closeButton.style.background = "none";
    closeButton.style.border = "none";
    closeButton.style.fontSize = "20px";
    closeButton.style.cursor = "pointer";
    closeButton.onclick = () => {
      document.body.removeChild(overlay);
    };

    toast.appendChild(closeButton);
    overlay.appendChild(toast);
    document.body.appendChild(overlay);
    // setTimeout(() => {
    //   document.body.removeChild(overlay);
    // }, 3000);
  };

  const handleGameLink = (game) => {
    let isMobileDevice =
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      window.innerWidth <= 1200;

    if (isMobileDevice) {
      if (game.app_link) {
        let iframe = document.createElement("iframe");
        iframe.style.display = "block";
        iframe.style.height = "1px";
        iframe.style.width = "1px";
        iframe.src = game.app_link;
        if (navigator.userAgent.match(/Safari/i)) {
          setTimeout(() => {
            showToast(
              "Oyunu açmakta sorun yaşıyorsanız lütfen iletişime geçiniz: contact@buckedgames.com"
            );
          }, 2000);
          window.top.location.href = game.app_link;
        }
        document.body.appendChild(iframe);
        let blurred = false;

        const onWindowBlur = () => {
          blurred = true;
          window.removeEventListener("blur", onWindowBlur);
        };

        window.addEventListener("blur", onWindowBlur);
        setTimeout(() => {
          document.body.removeChild(iframe);
          if (!blurred && document.hasFocus()) {
            showToast(
              "Oyunu açmakta sorun yaşıyorsanız lütfen iletişime geçiniz: contact@buckedgames.com"
            );
          }

          window.removeEventListener("blur", onWindowBlur);
        }, 3000);
      }
    } else {
      window.open(game.link, "_blank");
    }
  };

  return (
    <>
      <section className="header pt-16 flex justify-center h-60vh max-h-860-px bg-lightBlue-200">
        <div className="flex items-end">
          <img
            src={require("assets/img/bucked.png").default}
            alt="..."
            style={{ width: "200px", height: "auto" }}
          />
        </div>
      </section>
      <div className="bg-indigo-200 mt-8">
        <div className="container mx-auto">
          <div className="justify-center flex flex-wrap">
            <div className="w-full lg:w-12/12 px-4">
              <div className="flex flex-wrap">
                {games.map((game) => (
                  <div className="w-full lg:w-3/12 px-4" key={game.title}>
                    <div
                      onClick={() => handleGameLink(game)}
                      className="cursor-pointer"
                    >
                      <div className="hover:-mt-4 flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg ease-linear transition-all duration-150">
                        <img
                          alt={game.title}
                          className="align-middle border-none max-w-full h-auto rounded-lg"
                          src={game.image}
                        />
                        <h5 className="text-xl font-semibold pb-4 text-center">
                          {game.title}
                        </h5>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
